import { mitoPalettes } from "./tokens";

/** Rhemito / MITO-blue — same type scale as orange, Rhemito blue #2E5BFF. */
export const mitoBlueTheme = mitoPalettes.blue;

export default mitoBlueTheme;
